var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFaceSlightlysmilling = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84168 13.1223C5.86668 13.2218 6.49057 15.5551 10 15.5551C13.51 15.5551 14.1333 13.2218 14.1583 13.1223C14.1889 13.0018 14.1345 12.8768 14.0267 12.8146C13.9183 12.7529 13.7828 12.7712 13.6933 12.8573C13.6828 12.8679 12.6078 13.8885 10 13.8885C7.39223 13.8885 6.31668 12.8679 6.30668 12.8579C6.25334 12.8051 6.18223 12.7773 6.11112 12.7773C6.06445 12.7773 6.01723 12.789 5.97445 12.8129C5.86557 12.8751 5.81112 13.0012 5.84168 13.1223Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66672 9.44455C7.43378 9.44455 8.05561 8.574 8.05561 7.50011C8.05561 6.42622 7.43378 5.55566 6.66672 5.55566C5.89966 5.55566 5.27783 6.42622 5.27783 7.50011C5.27783 8.574 5.89966 9.44455 6.66672 9.44455Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 9.44455C14.1003 9.44455 14.7221 8.574 14.7221 7.50011C14.7221 6.42622 14.1003 5.55566 13.3332 5.55566C12.5662 5.55566 11.9443 6.42622 11.9443 7.50011C11.9443 8.574 12.5662 9.44455 13.3332 9.44455Z",
    fill: "#664500"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFaceSlightlysmilling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-face-slightlysmilling.1a8c8fcf6d4918c74364ad9a4dc8c033.svg";